var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "suc-date-time-field",
    _vm._g(
      _vm._b(
        { attrs: { title: _vm.$t("pages.planing-team.workshift.start_date") } },
        "suc-date-time-field",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }